import { Link } from "react-router-dom";
import { MapPin, Mail, Phone, Clock } from "lucide-react";
import { SITE } from "@/data/site";

export function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-brand-navy text-white/80">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div className="lg:col-span-1">
          <Link to="/" className="flex items-center gap-2.5">
            <span className="grid place-items-center h-11 w-11 rounded-xl bg-white overflow-hidden">
              <img src="/unirad-logo.png?v=2" alt="UNIRAD Diagnostics logo" className="h-9 w-9 object-contain" />
            </span>
            <span className="leading-none">
              <span className="block font-heading font-bold text-lg text-white">UNIRAD</span>
              <span className="block text-[10px] tracking-[0.25em] font-semibold text-brand-sky">DIAGNOSTICS</span>
            </span>
          </Link>
          <p className="mt-5 text-sm leading-relaxed text-white/60">
            Accurate diagnostic imaging, interventions, pathology in Lucknow, powered by modern technology and expert radiologists.
          </p>
        </div>

        <div>
          <h4 className="text-white font-heading font-semibold mb-4 text-base">Quick Links</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/" className="hover:text-brand-sky transition-colors">Home</Link></li>
            <li><Link to="/services" className="hover:text-brand-sky transition-colors">Services</Link></li>
            <li><Link to="/about" className="hover:text-brand-sky transition-colors">About Us</Link></li>
            <li><Link to="/contact" className="hover:text-brand-sky transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-heading font-semibold mb-4 text-base">Services</h4>
          <ul className="space-y-2.5 text-sm text-white/60">
            <li>Ultrasound & Doppler</li>
            <li>Digital X-Ray</li>
            <li>Pathology & Blood Tests</li>
            <li>Interventional Procedures</li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-heading font-semibold mb-4 text-base">Get in Touch</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li className="flex gap-3"><MapPin className="h-4 w-4 mt-0.5 text-brand-sky shrink-0" /><span>{SITE.address.full}</span></li>
            <li className="flex gap-3"><Phone className="h-4 w-4 mt-0.5 text-brand-sky shrink-0" /><span>{SITE.phones.map((p) => p.number).join(" · ")}</span></li>
            <li className="flex gap-3"><Mail className="h-4 w-4 mt-0.5 text-brand-sky shrink-0" /><span>{SITE.email}</span></li>
            <li className="flex gap-3"><Clock className="h-4 w-4 mt-0.5 text-brand-sky shrink-0" /><span>Mon–Sat 7AM–9PM · Sun 8AM–2PM</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-5 sm:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-white/50">
          <p>© {new Date().getFullYear()} UNIRAD DIAGNOSTICS. All rights reserved.</p>
          <p>Best Diagnostic & Imaging Center in Lucknow</p>
        </div>
      </div>
    </footer>
  );
}
